<!--
Component for the classes carousel.
@author crm4f
-->
<template>
  <div class="eventsCarouselContainer">

    <HomepageCarousel v-if="eventsToUse.length" name="events" :isPrimary="1===1">
      <CarouselItem v-bind:key="index" v-for="(event, index) in eventsToUse" :id ="'events' + index" @itemClick="(clickEvent) => handleClick(clickEvent, event)">
        <div class="timeContainer">
          <p>{{ formatEventTime(event.start) }}<br />-<br />{{ formatEventTime(event.end) }}</p>
        </div>
        <div class="infoContainer">
          <p id="eventTxt"><strong>{{ event.course }}</strong><br />{{ event.location }}</p>
          <p v-if="event.lecturer != null">{{ event.lecturer }}</p>
        </div>
      </CarouselItem>
    </HomepageCarousel>

    <div class="noEventsDiv" v-else>
      <!-- no classes -->
      <span>No more scheduled classes today.</span>
    </div>

    <ViewMoreButton :text="'View timetable'" :featureLink="'/timetable'" :isPrimary="1===1" ></ViewMoreButton>

  </div>
  <ClassPopUp
      :date = "new Date(event.date)"
      :title = "event.title"
      :startTime = "event.start"
      :endTime = "event.end"
      :location = "event.location"
      :locationLink = "event.roomid ? linkToMaps(event.roomid,event.roomgrpcode) : null"
      :onlineClassLink = "handleMoodleHandoff"
      :classIf = "event.classif"
      :lecturer = "event.lecturer"
      :desc = "event.details"
      :classType = "event.classType"
      :roomBooking="event.isUserBooking"
      :room="event.room"
      :roomLink="linkToMaps(event.roomid)"
      :roomid="event.roomid"
      @close = "showTimetablePopup = false"
      v-if = "showTimetablePopup"
    />
</template>

<script setup>
// import StringUtil from '@/mixins/StringUtil.js'
import axios from 'axios'
import HomepageCarousel from '@/components/homepage/HomepageCarousel.vue'
import CarouselItem from '@/components/homepage/CarouselItem.vue'
import ViewMoreButton from './ViewMoreButton.vue'
import { ref, onMounted } from 'vue'
import { useTimetableMethods } from '@/composables/TimetableMethods'
import ClassPopUp from '@/components/timetable/ClassPopUp.vue'

const eventsToUse = ref([])
const timeTolerance = ref(15) // minutes

const { formatEventTime, linkToMaps } = useTimetableMethods()


//For class info popup
const showTimetablePopup = ref(false)
const event = ref(null)

onMounted (() => {
  getEvents()
})

function getEvents () {
  axios.get('/timetable/timetable/events', {
    params: {
      // this could be probably be better
      start: dateToUnixTs(new Date(new Date() - (timeTolerance.value * 60 * 1000))),
      end: dateToUnixTs(new Date(new Date().setHours(23, 59, 59, 999))),
      ts: Date.now()
    }
  })
    .then(response => {
      eventsToUse.value = response.data
      // sort dates based on whats closest to now
      eventsToUse.value.sort((a, b) => {
        let dateA = new Date(a.start)
        let dateB = new Date(b.start)
        let now = Date.now()
        let diffA = Math.abs(now - dateA)
        let diffB = Math.abs(now - dateB)
        return diffA - diffB
      })
    })
    .catch((error) => {
      console.log(error)
    })
}

function dateToUnixTs (date) {
  return date.getTime() / 1000 | 0
}

function handleClick(clickEvent, classDetails) {
  showTimetablePopup.value = !showTimetablePopup.value
  event.value = classDetails
}

//This is taken from DailyAgenda.vue which also uses the ClassPopup component.
//TODO: Make this into a composable and use both components
function formatDateTitle(date) {
  let title = date.toLocaleDateString('en-GB', {weekday: 'short'})
  const nth = (d) => {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
      case 1:  return "st"
      case 2:  return "nd"
      case 3:  return "rd"
      default: return "th"
    }
  }
  title += ' ' + date.getDate() + nth(date.getDate()) + ' ' + date.toLocaleDateString('en-GB', {month: 'long'})
  return title
}

</script>

<style>

.infoContainer {
  display: flex;
  flex-flow: column wrap;
  word-wrap: break-word;
  white-space: pre-line;
  justify-content: center;
  height: fit-content;
  margin: 5px;
  padding: 5px;
}

.swiper {
  width: 600px;
  height: 300px;
}

.timeContainer {
  display: flex;
  flex-flow: column wrap;
  padding: 5px;
  margin: 5px;
  justify-content: center;
}

#eventTxt {
  margin-bottom: 0px;
}

.timeContainer p {
  margin-bottom: 3px !important;
  height: fit-content;
  text-align: center;
}

.infoContainer p {
  margin-bottom: 0px;
}

.noEventsDiv {
  width: 75%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

div.scrollover {
  height: 250px;
  overflow-x:auto;
  overflow-y:hidden;
  white-space: nowrap;

  -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.scrollover::-webkit-scrollbar {
  display: none;
}
</style>
